import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import QueryString from 'query-string';
import ReactTable from 'react-table';
import i18next from 'i18next';

import { Message } from '../Message';
import { PageTitle } from '../PageTitle';
import { RowButton } from '../RowButton';
import { ChecklistConfigsService } from '../../services';
import { AccessHelper, BaseTable } from '../../helpers';

@connect(state => {
  return {
    me: state.user.me
  }
})
class Checklists extends React.Component {
  constructor(props) {
    super(props);

    const passedState = props.history.location ? props.history.location.state : null;

    this.DEFAULT_SORTED = [];

    this.state = {
      linkTo: null,
      localErrorHandler: this.handleLocalError.bind(this),
      localErrorMessage: null,
      hasError: false,
      data: [],
      pageCount: null,
      forcePage: null,
      totalElements: null,
      loading: true,
      parsedOptions: QueryString.parse(this.props.location.search),
      currentHistoryCount: passedState && passedState.currentHistoryCount ? passedState.currentHistoryCount : 0,
      viewAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/config/checklists/view/:checklistId'),
      editAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/config/checklists/edit/:checklistId'),
    };
  }

  messageDismissCallback() {
    this.setState({ localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage) {
      return (
          <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
      );
    }

    if (this.props.location.state) {
      return (
          <Message messages={this.props.location} />
      );
    }
    return null;
  }

  handleLocalError(localErrorMessage) {
    this.setState({ localErrorMessage: localErrorMessage });
  }

  viewLinkClick(rowId) {
    this.setState({ linkTo: `/config/checklists/view/${rowId}` });
  }

  editLinkClick(rowId) {
    this.setState({ linkTo: `/config/checklists/edit/${rowId}` });
  }

  copyClicked(rowId) {
    this.setState({ loading: true });

    ChecklistConfigsService.get(rowId).then((response) => {
      let copiedChecklist = response.checklistConfiguration;
      copiedChecklist.id = null;
      copiedChecklist.name = `${response.checklistConfiguration.name} ${i18next.t('copy')}`;

      ChecklistConfigsService.add(copiedChecklist).then((_) => {
        this.fetchData();
      }).catch(error => {
        this.setState({ hasError: true, loading: false });
        this.state.localErrorHandler(i18next.t('messages.could-not-copy-checklist'));
        console.log(error);
      })

    }).catch((error) => {
      this.setState({ hasError: true, loading: false });
      this.state.localErrorHandler(i18next.t('messages.could-not-copy-checklist'));
      console.error(error);
    });
  }

  fetchData(tableData) {
    if (this.updateRequestURL(tableData)) {
      return;
    }

    this.setState({ loading: true });

    let options = BaseTable.buildFetchDataOptions(this.state.parsedOptions, this.DEFAULT_SORTED);

    ChecklistConfigsService.getAll(options, true).then(response => {
      const pageCount = Math.ceil(response.page.totalElements / this.refs.checklistsTable.state.pageSize);

      let forcePage = null;
      if (this.refs.checklistsTable && this.refs.checklistsTable.state
        && this.refs.checklistsTable.state.page >= pageCount) {
        forcePage = pageCount - 1;
      }
      this.setState({
        data: response.checklists,
        pageCount: pageCount,
        forcePage: forcePage,
        totalElements: response.page.totalElements,
        loading: false
      });
    }).catch(error => {
      console.error(error);
      this.setState({ hasError: true });
      this.state.localErrorHandler(error.message);
    });
  }

  updateRequestURL(tableData) {
    let options = BaseTable.buildURLOptions(tableData, this.DEFAULT_SORTED);

    let params = options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');

    const currentSearch = this.props.location.search ? this.props.location.search : '?';

    if (`?${params}` !== currentSearch) {
      if (this.state.currentHistoryCount > 100) {
        console.error('Exceeded the history count stack of 100.');
        return false;
      }
      this.props.history.push({
        search: `?${params}`,
        state: {
          currentHistoryCount: this.state.currentHistoryCount + 1
        }
      });
      return true;
    } else {
      return false;
    }
  }

  render() {
    if (this.state.linkTo) {
      return <Redirect push to={{ pathname: this.state.linkTo, state: { backLinkSearch: this.props.location.search }}} />;
    }

    let dynamicOptions = BaseTable.buildDynamicOptions(this.state.parsedOptions, this.state.forcePage, this.DEFAULT_SORTED);

    return (
        <div className="animated fadeIn">

          <div className="row">
            <PageTitle title={i18next.t('pages.checklists.header')}
                       addLinkWithParams={{
                         link: {
                           pathname: "/config/checklists/add",
                           state: {
                             backLinkSearch: this.props.location.search
                           }
                         }
                       }} />
          </div>
          {this.renderMessages()}

          <div className="op-content-box">
            <div className="row">
              <div className="col-sm-12">
                <div>
                  <div className="card-block">
                    <div className="react-table-custom">
                      <ReactTable
                        className="-striped -highlight"
                        ref="checklistsTable"
                        manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                        data={this.state.data}
                        pages={this.state.pageCount} // Display the total number of pages
                        loading={this.state.loading} // Display the loading overlay when we need it
                        totalElements={this.state.totalElements}
                        onFetchData={this.fetchData.bind(this)} // Request new data when things change

                        showPaginationTop
                        columns={[
                                    {
                                      Header: i18next.t('table-headers.name'),
                                      accessor: "name",
                                      sortable: true,
                                      minResizeWidth: 150
                                    },
                                    {
                                      Header: 'Version',
                                      accessor: 'version',
                                      sortable: false,
                                      minResizeWidth: 90,
                                      width: 90
                                    },
                                    {
                                      Header: 'Schedule?',
                                      accessor: 'checklistScheduleConfig',
                                      Cell: ({value}) => <span>{value ? 'Yes' : 'No'}</span>,
                                      sortable: false,
                                      minResizeWidth: 115,
                                      width: 115
                                    },
                                    {
                                      Header: 'Tags',
                                      accessor: 'tags',
                                      Cell: ({value}) => <span>{value.map(t => t.name).join(", ")}</span>,
                                      sortable: false,
                                      minResizeWidth: 100,
                                      width: 100
                                    },
                                    {
                                      Cell: cell => <RowButton
                                                        allowView = {this.state.viewAllowed}
                                                        allowEdit = {this.state.editAllowed}
                                                        allowCopy = {true}
                                                        editClick = {this.editLinkClick.bind(this)}
                                                        viewClick = {this.viewLinkClick.bind(this)}
                                                        copyClick = {this.copyClicked.bind(this)}
                                                        rowId = {cell.original.id} />,
                                      sortable: false,
                                      minResizeWidth: 200,
                                      width: 275
                                    }
                                  ]}
                        {...dynamicOptions}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default Checklists;
